// extracted by mini-css-extract-plugin
module.exports = {"colon":"Colon_colon__Kf2df"};